import { Reducer } from "redux";
import * as emailTemplateActions from "./emailTemplateActions";
import produce from "immer";
import { EmailTemplateItem } from "../../model/EmailTemplateItem";

export interface EmailTemplateState {
  isLoadingEmailTemplates: {
    [orgKeyName: string]: undefined | boolean;
  };
  emailTemplates: {
    [orgKeyName: string]: undefined | Array<EmailTemplateItem>;
  };
}

const initialState: EmailTemplateState = {
  isLoadingEmailTemplates: {},
  emailTemplates: {},
};

type SupportedActions =
  | emailTemplateActions.GetEmailTemplatesAction
  | emailTemplateActions.GetEmailTemplatesFailAction
  | emailTemplateActions.GetEmailTemplatesSuccessAction;

export const emailTemplateReducer: Reducer<
  EmailTemplateState,
  SupportedActions
> = (state = initialState, action) => {
  return produce(state, (draftState) => {
    switch (action.type) {
      case emailTemplateActions.GET_EMAIL_TEMPLATES: {
        draftState.isLoadingEmailTemplates[action.organization] = true;
        break;
      }
      case emailTemplateActions.GET_EMAIL_TEMPLATES_SUCCESS: {
        draftState.isLoadingEmailTemplates[action.organization] = false;
        draftState.emailTemplates[action.organization] = action.items;
        break;
      }
      case emailTemplateActions.GET_EMAIL_TEMPLATES_FAIL: {
        draftState.isLoadingEmailTemplates[action.organization] = false;
        break;
      }
      default: {
        return;
      }
    }
  });
};
